<template>
	<div>
		<div class="row mb-2">
			<div class="col-5">
				<h1>{{$t('examiner-overview')}} for APP2S03</h1>
			</div>
			<div class="col-7">
				<!-- <MenuModalBtn class="float-right"/> -->
			</div>
		</div>
		<div class="row">
			<!-- <div class="col-12 col-lg-4 order-lg-12 mb-4">
                <div class="list-group border-radius-2 no-border mb-3" >
					<div class="list-group-item">
						<h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t("quick-links") }}</h2>
					</div>
					<router-link to="/" class="list-group-item">{{
						$t("timings")
					}}</router-link>
					<router-link to="/" class="list-group-item">{{
						$t("schedule")
					}}</router-link>
					<router-link to="/" class="list-group-item">{{
						$t("messages")
					}}</router-link>
					<router-link to="/osces/examiners" class="list-group-item">{{
						$t("examiner")
					}}</router-link>
					<router-link to="/" class="list-group-item">{{
						$t("student")
					}}</router-link>
					<router-link to="/" class="list-group-item">{{
						$t("issues")
					}}</router-link>
                    <router-link to="/" class="list-group-item">{{
						$t("setup")
					}}</router-link>
				
				</div>
                <ReportWidget
                    :settings="{
                        header: 'osce-progress',
                        reportroute: 'oscestudentstats'
                    }"
                    class="mb-4"
                /> 
			</div> -->


			<div class="col-12 col-lg-12 order-lg-1">

                <h1>{{ $t('examiners') }}</h1>
                <Table
                    v-if="examiners.length"
                    :loading="loading"
                    :submitting="submitting"
                    :cols="[
                        { key: 'teacher_displayname', heading: $t('examiner-name'), size: 2 },
                        { key: 'not_started', heading: $t('not-started'), size: 2 },
                        { key: 'in_progress', heading: $t('in-progress'), size: 2 },
                        { key: 'editing', heading: $t('editing'), size: 2 },
                        { key: 'completed', heading: $t('completed'), size: 1 },
                        { key: 'alert', heading: $t('flags'), size: 1, icon: (item) => scoreIcon(item) },
                    ]"
                    :data="examiners"
                    breakpoint="md"
                    @selectItem="selectItem"
                    :filters="{
                        ...filters,
                        page: filters.page,
                        page_size: filters.page_size,
                        total_count: total_count
                    }"
                    :scrollPaginate="true"
                    @refresh="refresh"
                    @toPage="toPage"
                    :searchable="true"
                    class="mb-4"
                >
                <template v-slot:header>
                     <div class="list-group-item align-items-center">

						<div class="form-inline">
							<SelectInput
                                v-model="year"
								:options="[1,2,3,4]"
								:label="$t('year')"
								:srOnly="true"
                                :nullable="true"
                                :nullLabel="$t('year')"
								class="ml-2 mr-2 align-items-center"
							/>
                            <SelectInput
                                v-model="period"
                                :label="$t('period')"
                                :options="[1,2,3,4,5]"
                                :srOnly="true"
                                :nullable="true"
                                :nullLabel="$t('period')"
                                class="ml-2 mr-2 align-items-center"
                            />
                           
						</div>

                    </div>
                </template>
                </Table>
                <!-- <h1>{{ $t('completed-stations') }}</h1>
                <Table
                    v-if="osces.length"
                    :loading="loading"
                    :submitting="submitting"
                    :cols="[
                        { key: 'id', heading: $t('station-id'), size: 2 },
                        { key: 'station_number', heading: $t('station-number'), size: 2 },
                        { key: 'examiners', heading: $t('examiners'), size: 1 },
                        { key: 'total', heading: $t('number-of-students'), size: 3 },
                        { key: 'not_started', heading: $t('not-started'), size: 2 },
                        { key: 'completed', heading: $t('completed'), size: 1 },
                        { key: 'alert', heading: $t('flags'), size: 1, icon: (item) => scoreIcon(item) },
                    ]"
                    :data="osces"
                    breakpoint="md"
                    @selectItem="selectItem"
                    :filters="{
                        ...filters,
                        page: filters.page,
                        page_size: filters.page_size,
                        total_count: total_count
                    }"
                    :scrollPaginate="true"
                    @refresh="refresh"
                    @toPage="toPage"
                    :searchable="true"
                    class="mb-4"
                /> -->
			</div>
		</div>
	</div>
</template>

<script>
//import MenuModalBtn from "src/components/Workflows/MenuModalBtn.vue";
//import FeedbackWidget from "src/components/widgets/OSCE/FeedbackWidget";
//import LongitudinalTrackingWidget from "src/components/widgets/OSCE/LongitudinalTrackingWidget";
//import ReportWidget from "src/components/widgets/ReportWidget";
import Table from "src/components/Table/Table.vue";


export default {
	components: {
		//MenuModalBtn,
        //ReportWidget,
        //FeedbackWidget,
        Table,
        //LongitudinalTrackingWidget
	},
	computed: {
		isTeacher: function() {
			return this.$UserSession.hasPriv.call(this, "MARK_TREATMENTSESSIONS");
		}
	},
    data() {
        const today = new Date();
        const past = new Date(today);
        past.setDate(today.getDate() - 31);

        const future = new Date(today);
        future.setDate(today.getDate()+7);

        return {
            examiners:[
                {
                    id: 'APP2J01',
                    station_number: 4,
                    examiners: 3,
                    total: 100,
                    not_started: 10,
                    completed: 70,
                    in_progress: 20,
                    editting: 4,
                    title: 'Urine analysis',
                    description: 'The student will perform an urine analysis',
                    marked: true,
                    skill: 'Diagnostic procedures',
                    timestamp: '1763119518',
                    teacher_displayname: 'Indy Dehele',
                    score: 80
                },
                {
                    id: 'APP2S03',
                    station_number: 2,
                    examiners: 5,
                    total: 100,
                    not_started: 20,
                    completed: 70,
                    edititng: 2,
                    in_progress: 10,
                    title: 'Accuracy check',
                    description: 'The student will perform an accuracy check',
                    marked: true,
                    skill: 'Professional technical',
                    timestamp: '1663115518',
                    teacher_displayname: 'Jen Meers',
                    score: 50
                },
                {
                    id: 'APP3J03',
                    station_number: 10,
                    examiners: 7,
                    total: 100,
                    not_started: 30,
                    completed: 50,
                    in_progress: 20,
                    editing: 0,
                    title: 'Ear Examination',
                    description: 'Students perform an ear examination using an otoscope on a mannequin, diagnose a basic pathology and make recommendations for patient counselling',
                    marked: true,
                    skill: 'Diagnostic Examination',
                    timestamp: '1661115518',
                    teacher_displayname: 'Jane Doe',
                    score: 90
                }
            ],
            total_count: 0,
            loading: false,
            submitting: false,
            showadvancedsearch:false,
            students:[],
            ready:false,
            ttsessiontypes:[],
            ttrooms:[],
            filters: {
                page: 1,
                page_size: 30,
                search: '',
                order: '',
                programme: '',
                year: '',
                attended: false,
                absent: true,
                unknown: true,
                students: [],
                datetime_from: past.toISOString().split('T')[0],
                datetime_to: future.toISOString().split('T')[0]
            },
            downloading: false,
            
            year: null,
            period: null
            //item:{}
        }
    },
    methods: {
        selectItem(item){
        	this.$router.push(`/attendance/register/${item.ttevent_id}`);
        },
        scoreIcon(item){
            if(item.score >= 90) return { icon: 'check-circle-fill', variant: 'success' };
            if(item.score <= 50) return { icon: 'x-circle-fill', variant: 'danger' };
            return { icon: 'exclamation-circle-fill', variant: 'warning'}
        },
        refresh(filters) {
            this.filters = { ...this.filters, ...filters, page: 1 }
            this.fetchReport()
        },
        toPage(pageNo) {
            this.filters.page = pageNo
            this.fetchReport()
        },
    }
};
</script>
